import keyBy from "lodash/keyBy";
import { Currency } from "@zapier/currency";
import {
  currencyRulesetQuery_account_currencyRuleset as CurrencyRulesetItem,
  SupportedPaymentMethod,
} from "@zapier/payment/esm/types";

type Params = {
  currencyRuleset: CurrencyRulesetItem[];
  selectedCurrency: Currency;
  supportedMethods: SupportedPaymentMethod[];
};

export const resolveSupportedMethods = ({
  currencyRuleset,
  selectedCurrency,
  supportedMethods,
}: Params) => {
  const methodsList = supportedMethods.map(
    (m: SupportedPaymentMethod) => m.method
  );
  const processorsByMethod = keyBy(supportedMethods, "method");

  return (
    currencyRuleset
      // filter out any items that the user can't pay with and are unrelated to the selected currency
      .filter(
        ruleset =>
          methodsList.includes(ruleset.method) &&
          ruleset.currency === selectedCurrency.name
      )
      // include `paymentProcessor` in each object
      .map(ruleset => ({
        ...ruleset,
        // @ts-ignore
        paymentProcessor: processorsByMethod[ruleset.method]?.paymentProcessor,
      }))
  );
};
